import * as React from 'react';
import b_ from 'b_';
import NumberView from 'shared/components/NumberView';

import './index.scss';

interface Props {
  children: number | null;
}

const b = b_.with('stock-top-card-price-diff');

export const PriceDiff: React.SFC<Props> = ({ children: value }) => (
  <div className={b()}>
    <NumberView
      className={b('value', {
        negative: value && value < 0,
      })}
      sign={false}
      maximumFractionDigits={2}
      unit="%"
      placeholder="-"
    >
      {value}
    </NumberView>
  </div>
);
